import { createEntityActionNames, createEntityActions, createEntitySelectorsNames } from "store/entities/actions";
import { ActionsUnion, createAction } from "store/helper";

import {
  IEmailDomain,
  ISyncDeleteEmailDomainPayload,
  IVerifyEmailDomainPayload,
  IVerifyFailureDomainPayload,
  IVerifySuccessDomainPayload,
} from "./interfaces";

export const EmailDomainActionsNames = {
  ...createEntityActionNames("EMAIL_DOMAIN"),
  SYNC_DELETE: "ENTITIES/EMAIL_DOMAIN/SYNC_DELETE",
  VERIFY: "ENTITIES/EMAIL_DOMAIN/VERIFY_REQUEST",
  VERIFY_SUCCESS: "ENTITIES/EMAIL_DOMAIN/VERIFY_SUCCESS",
  VERIFY_FAILURE: "ENTITIES/EMAIL_DOMAIN/VERIFY_FAILURE",
};

export const EMAIL_DOMAIN = {
  ...createEntityActionNames("EMAIL_DOMAIN"),
};

export const EmailDomainSelectorsNames = {
  ...createEntitySelectorsNames("EMAIL_DOMAIN"),
};

export const EmailDomainActions = {
  ...createEntityActions<IEmailDomain>(EMAIL_DOMAIN),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  verify: (payload: IVerifyEmailDomainPayload) => createAction(EmailDomainActionsNames.VERIFY, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  verifySuccess: (payload: IVerifySuccessDomainPayload) =>
    createAction(EmailDomainActionsNames.VERIFY_SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  verifyFailure: (payload: IVerifyFailureDomainPayload) =>
    createAction(EmailDomainActionsNames.VERIFY_FAILURE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncDelete: (payload: ISyncDeleteEmailDomainPayload) => createAction(EmailDomainActionsNames.SYNC_DELETE, payload),
};

export type EmailDomainAction = ActionsUnion<typeof EmailDomainActions>;
